var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArtComebackLater = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "m99.083 81.04 23.161 55.79c2.131 5.132 6.286 9.221 11.583 10.898 17.993 5.696 30.892 5.861 48.577.514 6.273-1.897 10.886-7.151 12.518-13.498l4.908-19.085a20 20 0 0 1 1.008-2.948l11.372-26.334a20 20 0 0 0-2.574-20.207l-17.723-22.786a11.11 11.11 0 0 0-13.997-2.982c-3.094 1.65-6.833 1.72-10.006.227-5.471-2.575-12.094-.48-14.983 4.833L135.47 77.56c-2.126 3.908-7.617 4.225-10.178.586l-5.852-8.317a11.69 11.69 0 0 0-13.802-4.166c-6.11 2.38-9.07 9.32-6.555 15.376"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#223B90",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M145 82c10 2.5 32.5 15.4 36.5 23M156 83l17-41m-2.5 51 31-41"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F56B57",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M219.5 89.5c6.833 5.167 21.4 21.7 25 46.5M210.5 105.5c3.833 2.5 12.1 9.9 14.5 19.5"
})));
export default SvgArtComebackLater;